import RecordAPI from '../../api/record.js'

export const record = {
    namespaced: true,
    state: {
        records: {},
        lastUpdate: null,
    },

    actions: {
        RECORDS: async ({ state, commit }) =>
            RecordAPI.refresh(state.lastUpdate)
                .then(({ data: { data: records, lastUpdate: lastUpdate } }) => {
                    commit('RECORDS', records)
                    commit('LAST_UPDATE', lastUpdate)
                }).catch(() => commit('RECORDS', []))
    },

    mutations: {
        RECORDS: (state, records) => state.records = Object.assign(state.records, records),
        LAST_UPDATE: (state, lastUpdate) => state.lastUpdate = lastUpdate,
    },

}
